import {useEffect, useState} from 'react';
import {areArraysEqual, areArraysEqualIgnoringOrder} from '../util';

/**
 * Used to memoize array reference until array is provided is not considered equal (deep equality) with previously provided array.
 * @param array Array to be memoized.
 * @param ignoreOrder Value indicating if order will be ignored when checking for equality of arrays.
 * @param comparer Comparer to be used when checking equality while ignoring order.
 * @returns Memoized array.
 */
export const useMemoArray = <T>(array: T[], ignoreOrder: boolean = false, comparer?: (a: T, b: T) => number) => {
  const [stateArray, setStateArray] = useState(array);

  // if comparer is not memoized this useEffect will trigger more often than expected
  // but with early exit will make sure we dont mutate state and equality check will first check ref equality,
  // so we actaully dont care about it
  useEffect(() => {
    const areEqual = ignoreOrder
      ? areArraysEqualIgnoringOrder(array, stateArray, comparer)
      : areArraysEqual(array, stateArray);

    if (areEqual) return;

    setStateArray(array);
  }, [array, comparer, ignoreOrder, stateArray]);

  return stateArray;
};
